import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";

function Logs() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  // Endpoint camuflado pelo Worker (não precisa mais do api_token)
  const ENDPOINT = "https://api.sobevenda.com.br/api-proxy/script/list-webhook-logs";

  const fetchLogs = () => {
    setLoading(true);

    axios.get(ENDPOINT, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`,
      },
        // Se seu sistema salva o JWT do login no localStorage como 'authToken', descomente a linha abaixo e garanta que está correto
        // headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` },
        withCredentials: true, // Só precisa se estiver usando cookies para autenticação
      })
      .then((response) => {
        let data = response.data;
        if (Array.isArray(data)) {
          setLogs(data);
        } else if (Array.isArray(data.logs)) {
          setLogs(data.logs);
        } else {
          setLogs([]);
        }
      })
      .catch(() => {
        toast.error("Erro ao buscar logs!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchLogs();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Logs</h1>
        <button
          onClick={fetchLogs}
          className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Atualizar
        </button>
      </div>

      {loading ? (
        <p>Carregando logs...</p>
      ) : logs.length === 0 ? (
        <p>Nenhum log encontrado.</p>
      ) : (
        <div className="bg-white shadow rounded-lg overflow-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="py-2 px-4 text-left">Origem</th>
                <th className="py-2 px-4 text-left">Status</th>
                <th className="py-2 px-4 text-left">Mensagem</th>
                <th className="py-2 px-4 text-left">Data</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log) => (
                <tr key={log.id} className="border-t">
                  <td className="py-2 px-4">{log.origin}</td>
                  <td className="py-2 px-4">{log.status}</td>
                  <td className="py-2 px-4">{log.message}</td>
                  <td className="py-2 px-4">
                    {log.created_at
                      ? new Date(
                          // created_at pode ser timestamp (em segundos) ou em ms
                          log.created_at > 9999999999
                            ? log.created_at
                            : log.created_at * 1000
                        ).toLocaleString()
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default Logs;
